module.exports = __webpack_public_path__ + "img/meeting-img-2.1e98a134.jpg";